import { graphql } from '../../../gql';

// TRIL-305: codegen graphql() op (not Apollo's untyped `gql`) — the other writer
// of userStore.user besides getUser. Typing `data.loginUser` means a dropped
// auth-critical selection fails `tsc` at the consumer. Selection set unchanged.
export const LOGIN_MUTATION = graphql(`
    mutation loginUser($input: LoginInput!) {
        loginUser(input: $input) {
            id
            interests
            newUser
            username
            firstName
            lastName
            email
            country
            zipPostalCode
            role
            active
            avatar
            bio
            accessToken
            refreshToken
            sessionId
            lastActive
            createdAt
            drafts {
                id
                textBlocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                textBlocksVersions {
                    blocks {
                        id
                        type
                        data {
                            paragraph
                            header
                            level
                            items{
                                id
                                text
                            }
                            file {
                                url
                            }
                            code
                            withBorder
                            withBackground
                            stretched
                            caption
                            style
                        }
                    }
                    id
                }
                username
                article
                createdAt
                updatedAt
                status
                categories
            },
            posts {
                id
                textBlocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                textBlocksVersions {
                    blocks {
                        id
                        type
                        data {
                            paragraph
                            header
                            level
                            items{
                                id
                                text
                            }
                            file {
                                url
                            }
                            code
                            withBorder
                            withBackground
                            stretched
                            caption
                            style
                        }
                    }
                    id
                }
                author {
                    authorId
                    bio
                    username
                }
                postAnalytics {
                    id
                    author {
                        username
                        userId
                    }
                    metrics {
                        replies
                        votes {
                            upVotes 
                            downVotes 
                        }
                        hidden
                        reportedPost {
                            reportedTimes
                            causes
                        }
                        votesCount {
                            upVotes
                            downVotes
                        }
                        replyCount
                        repostCount
                        bookmarkCount
                    }
                }
                article
                createdAt
                updatedAt
                # Viewer-specific fields
                viewerInteractions {
                    hasLiked
                    hasReposted
                    hasBookmarked
                }
            },
            authorReputation {
                sentiment
                volatilityIndex
                metrics {
                    posts
                    following
                    followers
                }
            }
            userProfile {
                isPublicPerson
                displayName
                professionalContext {
                    expertiseAreas
                    educationLevel
                    currentProgram
                    fieldOfStudy
                    institution
                    jobTitle
                    yearsExperience
                    credentials {
                        id
                        title
                        issuer
                        year
                        expiryYear
                        link
                    }
                    updatedAt
                }
            }
            userPreferences {
                theme
                landingPage
                avatarUrl
                planCNudgeDismissedAt
                planCNudgeDismissCount
                planCPromptDismissCount
                planCOptedOut
                navCollapsed
            }
            upVotedPosts
            downVotedPosts
        }
    }
`);
